import Text from 'src/components/ui/Text'
import { BasePackCard, type BasePackCardProps } from './BasePackCard'

export type MonthlyPackCardProps = Omit<BasePackCardProps, 'topBadge'>

export function MonthlyPackCard(props: MonthlyPackCardProps) {
  const topBadge = (
    <div className="bg-[--monthly-badge-bg] text-[--monthly-badge-fg] py-0.5 px-2 text-center text-xs md:text-sm font-semibold uppercase rounded-full tracking-wide">
      <Text
        i18nKey="membership:package.monthly-one-time.badge.treatment.label"
        defaults="Monthly Offer"
      />
    </div>
  )

  return <BasePackCard {...props} topBadge={topBadge} />
}
